(function ($, Drupal, drupalSettings) {
  'use strict';

  Theme.all = function (common, options) {
    // Héritage
    this.common = common;

    // Selecteurs
    this.selectors = {
      // EXEMPLES : Data,Hover; Focus...
    };

    // Éléments
    this.elements = {
      html: $('html'),
      body: $('body'),
      blockView: $('div.block-view-display-list-news'),
      blockGalery: $('.paragraph--type--block-galery .galery--content'),
      blockSlider: $('.paragraph--type--block-slider').not('.style-slider-2'),
      blockSliderNumber: $('.paragraph--type--block-slider.style-slider-2'),
      blockTestimonials: $('.block-testimonials--content'),
      formMobileOpenLandingPage: $('#call-to-action-landing-page'),
      formMobileCloseLandingPage: $('#close-to-action-landing-page'),
      formLandingPage: $('.submit-landing'),
    };
    this.elements.viewForm = this.elements.blockView.find('form.views-exposed-form');
    //console.log(this.elements.viewForm);

    // Variables
    this.customForm = undefined;
  };

  Theme.all.prototype = {
    init: function () {
      this.menuStickyHandler();
      this.blockLogoHandler();
      this.blockSearchHandler();
      this.blockAnchorsHandler();
      this.stickyContactHandler();
      if ($('#block-menu-main').length) {
        this.blockMenuMainHandler();
      }
      this.blockSliderHandler();
      this.blockSliderNumberHandler();
      this.blockTestimonialsHandler();
      this.blockFaqHandler();
      this.blockVideoHandler();
      this.blockSliderReinssuranceRefreshHandler();
      this.blockSliderContainerExpertiseRefreshHandler();
      this.blockSliderCardViewRefreshHandler('view-display-latest-news', 1024);
      this.blockSliderCardViewRefreshHandler('view-display-new-last-by-agency');
      this.blockSliderCardViewRefreshHandler('view-display-new-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-expertise');
      this.blockSliderCardViewRefreshHandler('view-display-customer-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-solution');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-agency');
      this.formHandler();
      this.modalHandler();
      this.articleShareHandler();
      this.navFooterHandler();
    },

    load: function () {
      console.log('load');
      this.blockGaleryHandler();
      this.customFormHandler();
      this.blockSliderReinssuranceRefreshHandler();
      this.blockSliderContainerExpertiseRefreshHandler();
      this.blockSliderCardViewRefreshHandler('view-display-latest-news', 1024);
      this.blockSliderCardViewRefreshHandler('view-display-new-last-by-agency');
      this.blockSliderCardViewRefreshHandler('view-display-new-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-expertise');
      this.blockSliderCardViewRefreshHandler('view-display-customer-random');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-solution');
      this.blockSliderCardViewRefreshHandler('view-display-customer-last-by-agency');
    },
    autoload: function (options) {
      console.log('autoload');
    },

    /**
     * Block Logo
     */
    blockLogoHandler: function () {
      if ($(window).width() < 768) {
        $('#block-logo img').attr("src", "/themes/custom/drup_theme/logo-mobile.svg");
      }
      $(window).on('resize', function () {
        if ($(window).width() < 768) {
          $('#block-logo img').attr("src", "/themes/custom/drup_theme/logo-mobile.svg");
        } else if ($(window).width() > 768) {
          $('#block-logo img').attr("src", "/themes/custom/drup_theme/logo.svg");
        }
      });
    },

    /**
     * Menu Sticky
     */
    menuStickyHandler: function () {
      $(window).scroll(function () {
        if ($('body').hasClass('home')) {
          if ($(this).scrollTop() > 150) {
            $('.header-site .navigation').css('transform', 'translateY(-100%)');
          } else {
            $('.header-site .navigation').css('transform', 'translateY(0%)');
          }
        } else {
          if (!$('body[data-scrolltopprev]').length) {
            $('body').attr('data-scrolltopprev', $(this).scrollTop());
          }
          if ($(this).scrollTop() > 150 && $(this).scrollTop() > parseFloat($('body').attr('data-scrolltopprev'))) {
            $('.header-site .navigation').css('transform', 'translateY(-100%)');
          } else {
            $('.header-site .navigation').css('transform', 'translateY(0%)');
          }
          $('body').attr('data-scrolltopprev', $(this).scrollTop());
        }
      });
    },

    /**
     * Contact button
     */
    stickyContactHandler: function () {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
          if ($(window).width() < 768) {
            $('.contact-btn-sticky').css('right', '30px');
          } else {
            $('.contact-btn-sticky').css('right', '70px');
          }
        } else {
          if ($(window).width() < 768) {
            $('.contact-btn-sticky').css('right', '-30px');
          } else {
            $('.contact-btn-sticky').css('right', '-70px');
          }
        }
      });
    },

    /**
     * Block Galery
     */
    blockSearchHandler: function () {
      var self = this;
      $('body').on('click touch', '#icon-search', function (e) {
        e.preventDefault();
        $('.form--search').addClass('open');
      });
    },

    /**
     * Block Anchors
     */
    blockAnchorsHandler: function () {
      var self = this;

      $('.paragraph--type--item-container-header[id]').each(function () {
        //paragraph--type--container-anchors
        var idAnchor = $(this).attr('id');
        var labelAnchor = $(this).attr('data-label');
        var blocAnchorsPrev = $(this).closest('.paragraph-root').prevAll('.paragraph--type--container-anchors');

        if (blocAnchorsPrev.length) {
          var blocAnchorWrapper = blocAnchorsPrev.first().find('.paragraph--type--item-container-header');
          if (!blocAnchorWrapper.find('.anchors').length) {
            blocAnchorWrapper.append('<div class="anchors btn-group btn-color-border-grey btn-icon-long-arrow"></div>');
          }
          blocAnchorWrapper.find('.anchors').append('<a class="btn" href="#' + idAnchor + '">' + labelAnchor + '</a>')
        }
      });

      $('.anchors a').on('click touch', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        var topAnchor = $(target).offset().top - $('.pre-header').outerHeight() - 20;

        $('html, body').stop().animate({scrollTop: topAnchor}, 400);
      });

    },

    /**
     * Block Menu Main
     */
    blockMenuMainHandler: function () {
      /** Menu desktop **/
      /*$('body').on('mouseover touch focus', '#block-menu-main .level0--link', function (e) {
        e.preventDefault();

        var level0Item = $(this).closest('.level0--item');

        if (!level0Item.hasClass('active')) {
          $(this).closest('.level0').find('.level0--item.active').removeClass('active');
          level0Item.removeClass('inactive').addClass('active');
          $(this).closest('.level0').find('.level0--item:not(.active)').addClass('inactive');
        }
      });
      $('body').on('mouseover touch', function (e) {
        if (!e.target.closest('#block-menu-main')) {
          if ($('#block-menu-main .level0--item.active').length) {
            setTimeout(function () {
              $('#block-menu-main .level0--item').removeClass('active').removeClass('inactive');
            }, 300);
          }
        }
      });*/

      /** Menu mobile **/
      /* construction du menu mobile */
      $('#block-menu-main').after($('#block-menu-main').clone().attr('id', 'block-menu-main-mobile'));
      /* déplacement autres menus dans menu mobile */
      $('#block-menu-main-mobile .level0').append($('#block-menu-secondary .level0--item').clone());
      $('#block-menu-main-mobile .level0').append($('#block-menu-shortcuts .level0--item').clone());

      var barSearch = $('#site-search').clone();
      $('#block-menu-main-mobile .level-green').last().after(barSearch);

      const menu = new MmenuLight(document.querySelector("#block-menu-main-mobile"));
      const navigator = menu.navigation({
        title: '',
        theme: 'dark'
      });
      const drawer = menu.offcanvas({
        position: 'right'
      });
      $('.btn-menu-mobile.open').click(function (e) {
        $(this).removeClass('open');
        $(this).addClass('hidden');
        $('.btn-menu-mobile-open').removeClass('hidden');
          e.preventDefault();
          drawer.open();
        }
      );
      $('.btn-menu-mobile-open').click(function (e) {
          e.preventDefault();
          $(this).addClass('hidden');
          drawer.close();
          $('.btn-menu-mobile-close').removeClass('hidden');
        }
      );

      $('.mm-ocd--open .mm-ocd__backdrop').click(function (e) {
          e.preventDefault();
          $(this).addClass('hidden');
          drawer.close();
          $('.btn-menu-mobile-close').removeClass('hidden');
        }
      );


    },
    /**
     * Block Galery
     */
    blockGaleryHandler: function () {
      var self = this;
      if (self.elements.blockGalery.length) {

        // init Masonry
        var gridGalery = self.elements.blockGalery.masonry({
          columnWidth: self.elements.blockGalery.find('.paragraph--type--block-image')[1],
          horizontalOrder: true,
          percentPosition: true,
        });

        // layout Masonry after each image loads
        gridGalery.imagesLoaded().progress( function() {
          gridGalery.masonry();
        });
      }
    },

    /**
     * Block Slider
     */
    blockSliderHandler: function () {
      var self = this;

      if (self.elements.blockSlider.length) {
        self.elements.blockSlider.each(function () {

          // récup param autoplay
          var autoplayTimeout = 0;
          $(this).attr('class').split(' ').forEach(function (item) {
            if (item.indexOf('autoplay-') >= 0) {
              switch (item.replace('autoplay-', '')) {
                case 'slow' :
                  autoplayTimeout = 10000;
                  break;
                case 'fast' :
                  autoplayTimeout = 3000;
                  break;
                case 'normal' :
                  autoplayTimeout = 5000;
                  break;
                default :
                  autoplayTimeout = 0;
              }
            }
          });

          // slide video
          $(this).on('click touch', '.link-video-embed.open-here', function (e) {
            e.preventDefault();

            $(this).addClass('hide');

            // stop autoplay sur le slider
            if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
              $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
            }

            // lecture video
            $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
          });

          // init slider
          $(this).find('.block-slider--content-slide').addClass('owl-carousel').owlCarousel({
            autoplay: (autoplayTimeout > 0),
            autoplayTimeout: autoplayTimeout,
            responsiveClass: true,
            autoplayHoverPause: true,
            autoHeight: false,
            nav: $(this).hasClass('arrows'),
            navText: [
              '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>',
              '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>'
            ],
            dots: $(this).hasClass('dots'),
            autoWidth: false,
            items: 1,
            responsive: {
              0: {
                loop: false,
              },
              768: {
                loop: true,
              }
            },
            onChange: function (event) {
              //console.log(event.property.name);
              // si navigation dans slider en pause  suite à une lecture d'une vidéo : restart autoplay et stop vidéo
              if (event.property.name == 'position') {
                // restart autoplay
                if ($(event.target).autoplay) {
                  $(event.target).trigger('play.owl.autoplay');
                }

                // stop video
                //console.trace($(event.target));
                $(event.target).find('.paragraph--type--item-slider-slide').removeClass('play-video');
                $(event.target).find('.paragraph--type--item-slider-slide .content-video-embed').empty();
                $(event.target).find('.link-video-embed.hide').removeClass('hide');
              }
            }
          });
        });
      }
    },

    /**
     * Gestionnaire de CustomForm
     */
    customFormHandler: function () {
      var self = this;

      self.customForm = self.elements.viewForm.customForm();
      self.customForm.setSupport('checkbox', {
        beforeWrap: function () {
          this.wrapper.removeClass(this.customFormCheck.settings.classes.prefix + '--' + this.customFormCheck.element.type);
          this.wrapper.addClass('tag');
        },
        onClick: function () {
          this.customFormCheck.element.context.find('input[type="submit"]').trigger('click');
        }
      });
    },

    /**
     * Block Slider
     */
    blockSliderNumberHandler: function () {
      var self = this;

      if (self.elements.blockSliderNumber.length) {
        self.elements.blockSliderNumber.each(function () {

          // récup param autoplay
          var autoplayTimeout = 0;
          $(this).attr('class').split(' ').forEach(function (item) {
            if (item.indexOf('autoplay-') >= 0) {
              switch (item.replace('autoplay-', '')) {
                case 'slow' :
                  autoplayTimeout = 10000;
                  break;
                case 'fast' :
                  autoplayTimeout = 3000;
                  break;
                case 'normal' :
                  autoplayTimeout = 5000;
                  break;
                default :
                  autoplayTimeout = 0;
              }
            }
          });

          // slide video
          $(this).on('click touch', '.link-video-embed.open-here', function (e) {
            e.preventDefault();

            $(this).addClass('hide');

            // stop autoplay sur le slider
            if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
              $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
            }

            // lecture video
            $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
          });

          // init slider
          $(this).find('.block-slider--content-slide').addClass('owl-carousel').owlCarousel({
            autoplay: (autoplayTimeout > 0),
            autoplayTimeout: autoplayTimeout,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: $(this).hasClass('arrows'),
            navText: [
              '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-gauche"></use></svg></div>',
              '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-droite"></use></svg></div>'
            ],
            dots: $(this).hasClass('dots'),
            autoWidth: false,
            items: 1,
            autoHeight: false,
            responsive: {
              0: {
                loop: false,
              },
              768: {
                loop: true,
              }
            },
          });
        });
      }
    },

    /**
     * Block Testimonials
     */
    blockTestimonialsHandler: function () {
      var self = this;

      if (self.elements.blockTestimonials.length) {
        self.elements.blockTestimonials.addClass('owl-carousel').owlCarousel({
          loop: true,
          autoplay: true,
          responsiveClass: true,
          autoplayHoverPause: true,
          autoHeight: false,
          nav: true,
          navText: [
            '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-gauche"></use></svg></div>',
            '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche-droite"></use></svg></div>'
          ],
          dots: false,
          autoWidth: false,
          items: 1
        });
      }
    },

    /**
     * Block Reassurance
     */
    blockSliderReinssuranceRefreshHandler: function () {
      var containerReinssurance = $('.paragraph--type--container-reinssurance .paragraph--row');
      var params = {
        loop: true,
        autoplay: true,
        responsiveClass: true,
        nav: true,
        navText: [
          '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>',
          '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg></div>'
        ],
        dots: false,
        autoWidth: false,
        responsive: {
          0: {
            items: 1,
          }
        }
      };

      // Init before resize
      if ($(window).width() < 800) {
        containerReinssurance.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).on('resize', function () {
        if ($(window).width() < 800 && !containerReinssurance.hasClass('owl-carousel')) {
          containerReinssurance.addClass('owl-carousel').owlCarousel(params);
        } else if ($(window).width() > 800) { // Not mobile but slider built = destroy
          containerReinssurance.trigger('destroy.owl.carousel').removeClass('owl-carousel');
        }
      });
    },

    /**
     * Block Col Expertise
     */
    blockSliderContainerExpertiseRefreshHandler: function () {
      var containerExpertise = $('.paragraph--type--container-expertise .paragraph--row');
      var containerPushMobile = $('.paragraph--type--container-expertise .push-expertise');

      var pushExpertiseClone = $('.push-expertise').clone();
      var pushExpertiseCloneCustom = pushExpertiseClone.addClass('custom-push-expertise').removeClass('push-expertise');

      var params = {
        stagePadding: 0,
        margin: 25,
        loop: true,
        autoplay: false,
        responsiveClass: true,
        dots: false,
        autoWidth: false,
        responsive: {
          0: {
            items: 1.2,
            margin: 25,
          },
          768: {
            items: 3.4,
            margin: 25,
          }
        }
      };

      // Init before resize
      if ($(window).width() < 768) {
        if($('.custom-push-expertise').length == 0) {
          $('.paragraph--type--container-expertise .paragraph--type--item-container-footer').before(pushExpertiseCloneCustom);
          $('.push-expertise').remove();
        }
        containerExpertise.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).on('resize', function () {
        if ($(window).width() < 768 && !containerExpertise.hasClass('owl-carousel')) {
          if($('.custom-push-expertise').length == 0) {
            $('.paragraph--type--container-expertise .paragraph--type--item-container-footer').before(pushExpertiseCloneCustom);
          }
          containerExpertise.addClass('owl-carousel').owlCarousel(params);
        } else if ($(window).width() > 768) { // Not mobile but slider built = destroy
          $('.custom-push-expertise').remove();
          containerExpertise.trigger('destroy.owl.carousel').removeClass('owl-carousel');
        }
      });
    },

    /**
     * Block Card News
     */
    blockSliderCardViewRefreshHandler: function (classView, breakpointSlider) {
      var containerViewCardNew = $('.'+classView+' .view-list');
      if( typeof(breakpointSlider) == 'undefined' ){
          breakpointSlider = 768;
      }
      var params = {
        loop: true,
        autoplay: true,
        responsiveClass: true,
        dots: false,
        autoWidth: false,
        responsive: {
          0: {
            items: 1.2,
            margin: 25,
          }
        }
      };

      // Init before resize
      if ($(window).width() < breakpointSlider) {
        containerViewCardNew.addClass('owl-carousel').owlCarousel(params);
      }
      $(window).resize(function () {
        if ($(window).width() < breakpointSlider && !containerViewCardNew.hasClass('owl-carousel')) {
          containerViewCardNew.addClass('owl-carousel').owlCarousel(params);
        } else if ($(window).width() > breakpointSlider) { // Not mobile but slider built = destroy
          containerViewCardNew.trigger('destroy.owl.carousel').removeClass('owl-carousel');
        }
      });
    },

    /**
     * Block FAQ
     */
    blockFaqHandler: function () {
      $('body').on('click touch', '.paragraph--type--block-faq .field_question', function (e) {
        e.preventDefault();
        $(this).addClass('selected');
        $(this).closest('.paragraph--type--block-faq').find('.field_question:not(.selected)').removeClass('active');
        $(this).removeClass('selected').toggleClass('active');
      });
    },

    /**
     * Block video
     */
    blockVideoHandler: function () {
      $('body').on('click touch', '.paragraph--type--block-video-embed .block-video-embed--link.open-here', function (e) {
        e.preventDefault();
        $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
        $(this).closest('.paragraph--type--block-video-embed').addClass('play');
      });
    },

    /**
     * Gestionnaire de la navigation principale en responsive
     */
    formHandler: function () {
      var self = this;

      if (self.elements.formLandingPage.length) {
        self.elements.formMobileOpenLandingPage.click(self.callOpenFormLandingPageEvent);
        self.elements.formMobileCloseLandingPage.click(self.callCloseFormLandingPageEvent);
      }
    },

    /**
     * Gestionnaire du formulaire d'ouverture (version mobile) de la landing page
     */
    callOpenFormLandingPageEvent: function (e) {
      e.preventDefault();
      $("html").css({'overflow': 'hidden', 'position': 'fixed', 'height': '100%', 'width': '100%'});
      $("body").css({'overflow': 'hidden', 'position': 'fixed', 'height': '100%', 'width': '100%'});
      var heightScroll = window.innerHeight - $(".section-right-header").height();
      $('.content-page-landing-card-right').css({"transform": "translate(0px)", "height": "100vh"});
      var styles = {
        "height": heightScroll + "px",
        "overflow-x": "scroll",
        top: "0"
      };
      $('#form-landing-page').css(styles);
    },

    /**
     * Gestionnaire du formulaire de fermeture (version mobile) de la landing page
     */
    callCloseFormLandingPageEvent: function (e) {
      e.preventDefault();
      $("html").removeAttr('style');
      $("body").removeAttr('style');
      $('.content-page-landing-card-right').removeAttr('style');
      $('#form-landing-page').removeAttr('style');
    },

    /**
     * Gestionnaire de partage d'article par email
     */
    articleShareHandler: function () {
      $('#share-submit').click(function (e) {
        e.preventDefault();
        var button = $(this);
        var modal = button.parents('form');
        var alert_fields = $('.alert');
        if (alert_fields.length > 0) {
          alert_fields.each(function (field) {
            $(this).removeClass('alert');
          });
        }

        $.ajax({
          url: '/ajax/emailshare',
          type: 'POST',
          data: modal.serialize() + "&url=" + window.location.href,
          dataType: 'json',
          success: function (data) {
            if (data.errors.length > 0) {
              var errors_html = '';
              data.errors.forEach(function (error) {
                errors_html += error['message'] + '<br />';
                $('#' + error['error']).addClass('alert');
              });
              $('.errors').html(errors_html);
            } else {
              $('.container-modal-form').addClass('container-form').html('<h2 class="title3">Félicitations</h2><p>L’article a correctement été envoyée</p>');
            }
          },
          error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
          }
        });
      });
    },

    /**
     * Gestionnaire du modal du site
     */
    modalHandler: function () {
      var btnModalOpen = $('.btn-modal');
      var btnModalClose = $('.js-btn-close');

      if (btnModalOpen.length) {
        btnModalOpen.on('click', function (e) {
          e.preventDefault();
          var btnModalAttr = $(this).attr("data-modal");
          var modal = $("#" + btnModalAttr);
          $("#" + btnModalAttr + ' .btn-blue').attr("href", $(this).attr("href"));
          modal.addClass("open");
        });
      }
      if (btnModalClose.length) {
        btnModalClose.on('click', function (e) {
          e.preventDefault();
          var btnModalAttr = $(this).closest('div.open');
          var modal = $("#" + btnModalAttr[0].id);
          modal[0].classList.remove("open");
        });
      }
    },

    /**
     * Gestionnaire du footer en deux colonnes
     */
    navFooterHandler: function () {
      $('#block-menu-prefooter > ul').columnize();
    }
  };

}(jQuery, Drupal, drupalSettings));
